/**
 * Created by mongoose on 19/05/17.
 */
import moment from "moment";
import constants from "../../utils/constants";
import { dateDiffInDays, formatDate } from "../../utils/date";
import setQuery from "set-query-string";
import qs from "query-string";
import _ from "lodash";

function isBookingFormValid(requestParams) {
  return requestParams.startDate && requestParams.endDate;
}

export function submitBookingForm({
  startDate,
  endDate,
  propertyTicker: callingTicker,
  formValues,
  guestAges: ageSelectorGuestAges,
  bookingFormFields,
  locale,
  globalPropertyTicker,
  addAlert,
  requestARI,
  bookingForm,
  push,
  stay,
  promoCodes: promotionCodes,
  sessionId,
}) {
  const fields =
    bookingFormFields &&
    bookingFormFields.fields &&
    Object.keys(bookingFormFields.fields).filter(fieldName => bookingFormFields.fields[fieldName]);

  const bookingFormValues = fields.reduce((accumulator, field) => {
    let value;
    if (_.isObject(bookingForm[field])) {
      if (bookingForm[field].value) {
        value = bookingForm[field].value;
      }
    } else {
      value = bookingForm[field];
    }
    accumulator[field] = value || null;
    return accumulator;
  }, {});

  /* Todo: unify this logic for guest ages */
  let guestAges = null;
  if (
    formValues &&
    typeof formValues.childrenCount !== "undefined" &&
    formValues.childrenCount !== null
  ) {
    guestAges = [];
    const childrenCount = formValues.childrenCount;
    for (let idx = 0; idx < childrenCount; idx++) {
      guestAges.push(formValues[`age${idx}`]);
    }
    guestAges = guestAges.filter(it => !!it);
  }
  if (ageSelectorGuestAges) {
    guestAges = ageSelectorGuestAges;
  }

  if (!bookingFormValues.promoCodes && promotionCodes) {
    bookingFormValues.promoCodes = promotionCodes;
  }

  if (_.isObject(bookingFormValues.promoCodes && bookingFormValues.promoCodes.values)) {
    promoCodes = bookingFormValues.promoCodes.values;
  }

  if (typeof bookingFormValues.promoCodes === "string") {
    bookingFormValues.promoCodes = bookingFormValues.promoCodes.toLowerCase();
  }

  const requestParams = {
    ...bookingFormValues,
    locale,
    propertyTicker: globalPropertyTicker,
    stay,
  };
  if (startDate && endDate) {
    requestParams.startDate = startDate;
    requestParams.endDate = endDate;
  }
  if (guestAges) {
    requestParams.guestAges = guestAges;
  }

  if (formValues && formValues.propertyTickers && formValues.propertyTickers.length > 0) {
    requestParams.propertyTickers = formValues.propertyTickers;
  }
  if (!isBookingFormValid(requestParams)) {
    addAlert("error", "Invalid search", null);
  } else {
    if (window.self !== window.top && window.parent && window.parent.postMessage) {
      const eventParams = {
        ...requestParams,
        startDate: requestParams.startDate && moment(requestParams.startDate).format("DD-MM-YYYY"),
        endDate: requestParams.endDate && moment(requestParams.endDate).format("DD-MM-YYYY"),
      };
      window.parent.postMessage({ eventType: "witFormUpdated", params: eventParams }, "*");
    }
    push({
      pathname: `/${callingTicker ? callingTicker : globalPropertyTicker}/availability`,
      search: requestParams.stay,
    });
    requestARI({
      propertyTicker: globalPropertyTicker,
      callingTicker,
      newConfiguration: requestParams,
      track: true,
      sessionId,
    });
  }

  window.wbkStartDate = formatDate(requestParams.startDate, "DD-MM-YYYY");
  window.wbkEndDate = formatDate(requestParams.endDate, "DD-MM-YYYY");
  window.wbkNights = dateDiffInDays(requestParams.startDate, requestParams.endDate);
  window.wbkAdvance = dateDiffInDays(new Date(), requestParams.startDate);
  window.guestAges = requestParams.guestAges;
  window.wbkSeniors =
    !isNaN(requestParams[constants.OCCUPANTS_TYPE.SENIOR]) &&
    requestParams[constants.OCCUPANTS_TYPE.SENIOR];
  window.wbkAdults =
    !isNaN(requestParams[constants.OCCUPANTS_TYPE.ADULT]) &&
    requestParams[constants.OCCUPANTS_TYPE.ADULT];
  window.wbkTeenagers =
    !isNaN(requestParams[constants.OCCUPANTS_TYPE.TEENAGER]) &&
    requestParams[constants.OCCUPANTS_TYPE.TEENAGER];
  window.wbkChildren =
    !isNaN(requestParams[constants.OCCUPANTS_TYPE.CHILDREN]) &&
    requestParams[constants.OCCUPANTS_TYPE.CHILDREN];
  window.wbkBabies =
    !isNaN(requestParams[constants.OCCUPANTS_TYPE.BABY]) &&
    requestParams[constants.OCCUPANTS_TYPE.BABY];
}
